
export const dispatchAccountSetupAndWait = (dispatch, getState) => {
    return new Promise((resolve, reject) => {

        const timeout = setTimeout(() => {
            reject(new Error('Account setup timeout'));
        }, 30000);

        dispatch({ type: 'SETUP_ACCOUNT', payload: { state: 'WHATSAPP_SIGNUP' } });

        const interval = setInterval(() => {
            const state = getState().accountSetup;
            
            if (state.isComplete) {
                clearTimeout(timeout);
                clearInterval(interval);
                resolve(state);
            } else if (state.error) {
                clearTimeout(timeout);
                clearInterval(interval);
                reject(new Error(state.error));
            }
        }, 100);
    });
};
